import { render, staticRenderFns } from "./commision.vue?vue&type=template&id=55c8aea6&scoped=true"
import script from "./commision.vue?vue&type=script&lang=js"
export * from "./commision.vue?vue&type=script&lang=js"
import style0 from "./commision.vue?vue&type=style&index=0&id=55c8aea6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8aea6",
  null
  
)

export default component.exports